<template>
    <div>
        <Separator :label="$t('page.affiliated_events')"/>
        <!-- Selector -->
        <div class="container-fluid__with-padding">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-8 col-12">
                    <div class="tags-event">
                        <tag-item
                            v-for="subcategory in subcategories"
                            :key="subcategory.id"
                            :tag-item="subcategory"
                            :color="colorSubcategory"
                        />
                        <tag-item
                            v-for="label in labels"
                            :key="label.id"
                            :tag-item="label"
                            :color="colorLabel"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Separator from './Separator'
import TagItem from "./TagItem";

export default {
    name: "TagsItem",
    components: {
        Separator,
        TagItem
    },
    props: {
        labels: null,
        subcategories: null,
        colorLabel: null,
        colorSubcategory: null
    },
    computed: {},
    mounted() {

    },
    methods: {}
}
</script>

